export const TREE_INDENT_PX = 14;
export const TREE_ROOT_PADDING_PX = 16;
/** 親フォルダのシェブロン中心 (幅 16px の枠に 12px を右寄せ) の真下に線を通す。 */
const GUIDE_OFFSET_PX = TREE_ROOT_PADDING_PX + 10;

export const TREE_HOVER_GROUP_CLASS = "group/file-tree";

/** 各階層の縦線。行が隙間なく並ぶので、行ごとの線がつながって 1 本に見える。 */
export function TreeIndentGuides({ depth }: { depth: number }) {
	return Array.from({ length: depth }, (_, level) => (
		<span
			key={level}
			className="pointer-events-none absolute inset-y-0 w-px bg-tree-guide-line opacity-0 transition-opacity group-hover/file-tree:opacity-100 group-has-[:focus-visible]/file-tree:opacity-100"
			style={{ left: level * TREE_INDENT_PX + GUIDE_OFFSET_PX }}
		/>
	));
}
